module.exports = __webpack_public_path__ + "img/vk.a39bbafc.png";